<template>
  <li class="list-item">
    <a class="list-link" @click="handleClick">
      <div class="info">
        <div class="post-title">
          {{ prefix }} {{ item.title }}
        </div>
        <div class="post-excerpt" v-html="item.description" />
        <div class="post-name">
          {{ item.countryNm }} {{ item.writerNm }}
        </div>
        <div class="post-detail">
          <div class="view"><i class="ico ico-smile" />{{ formatNumber(item.viewCnt, locale) }}</div>
          <div class="comment"><i class="ico ico-reply" />{{ formatNumber(item.commentCnt, locale) }}</div>
        </div>
      </div>
      <div class="thum">
        <div class="thum-img" :style="{ backgroundImage: item.thumbnailUrl ? `url(${item.thumbnailUrl})` : undefined }" />
      </div>
    </a>
  </li>
</template>

<script lang="ts" setup>
import type { AnniversaryDocType, AnniversaryItemModel } from '~~/shared/types/models'

const props = defineProps<{
  item: AnniversaryItemModel
  type: AnniversaryDocType
}>()

const { $t } = useTranslation()
const localePath = useLocalePath()
const { locale } = useI18n()

const prefix = computed(() => {
  switch (props.item.selectionReasonType) {
    case '댓글BEST':
      return `[${$t('댓글best')}]`
    case '조회수BEST':
      return `[${$t('조회수best')}]`
    case '좋아요BEST':
      return `[${$t('좋아요best')}]`
    default:
      return ''
  }
})

function handleClick() {
  if (props.type === 'review') {
    navigateTo(localePath(`/review/${props.item.docId}`))
  }
  else {
    navigateTo(localePath(`/special/anniversary2nd/posts/${props.item.docId}`))
  }
}
</script>
